import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';

export const IconHeader = ({
  leftContent,
  middleContent,
  rightContent,
  onLeftClick,
  onRightClick,
  height = 56,
  width = '100%',
  px = '8x',
  py = '8px',
  leftTextColor = '#222',
  rightTextColor = '#222',
  leftTextSize = 20,
  rightTextSize = 20,
  leftImgSize = 32,
  rightImgSize = 32,
  middleImgSize = 32,
  borderBottom = 'none',
  borderColor = '#000000',
  sx = {},
}) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height,
      width,
      px: px,
      py: py,
      ...sx,
      borderBottom, 
      borderColor,
    }}
  >
    <Box
      onClick={onLeftClick}
      sx={{ display: 'flex', alignItems: 'center', cursor: onLeftClick ? 'pointer' : 'default' }}
    >
      {typeof leftContent === 'string' ? (
        <Typography sx={{ color: leftTextColor, fontSize: leftTextSize, fontWeight: 700 }}>
          {leftContent}
        </Typography>
      ) : React.isValidElement(leftContent) ? (
        leftContent
      ) : typeof leftContent === 'object' && leftContent?.src ? (
        <Box
          component="img"
          src={leftContent.src}
          alt={leftContent.alt || 'left'}
          sx={{  height: leftImgSize }}
        />
      ) : null}
    </Box>

     <Box
      // onClick={onLeftClick}
      sx={{ display: 'flex', alignItems: 'center' }}
    >
      {typeof middleContent === 'string' ? (
        <Typography sx={{ color: leftTextColor, fontSize: leftTextSize, fontWeight: 700 }}>
          {middleContent}
        </Typography>
      ) : React.isValidElement(middleContent) ? (
        middleContent
      ) : typeof middleContent === 'object' && middleContent?.src ? (
        <Box
          component="img"
          src={middleContent.src}
          alt={middleContent.alt || 'left'}
          sx={{  height: middleImgSize }}
        />
      ) : null}
    </Box>
    <Box
      onClick={onRightClick}
      sx={{ display: 'flex', alignItems: 'center', cursor: onRightClick ? 'pointer' : 'default' }}
    >
      {typeof rightContent === 'string' ? (
        <Typography sx={{ color: rightTextColor, fontSize: rightTextSize, fontWeight: 700 }}>
          {rightContent}
        </Typography>
      ) : React.isValidElement(rightContent) ? (
        rightContent
      ) : typeof rightContent === 'object' && rightContent?.src ? (
        <Box
          component="img"
          src={rightContent.src}
          alt={rightContent.alt || 'right'}
          sx={{ height: rightImgSize }}
        />
      ) : null}
    </Box>
  </Box>
);

export default IconHeader;